// extracted by mini-css-extract-plugin
export default {"productGallery":"cG-z","inQuickShop":"dG-z"};